import { providerCheckHandler } from 'globalutils/tenant/providerCheckHandler';
import { SERVICE_PROVIDERS } from '@/config/tenants/global';

// provider and SERVICE_PROVIDERS[key] will be same
const getProviderCheck = ({ verticalTab }) => {
  return {
    rowLen: {
      [SERVICE_PROVIDERS.SPIREON]: () => 36,
      default: () => (window.$environment.APP_LAYOUT === 'NewUi' ? 40 : 39),
    },
    wl: {
      [SERVICE_PROVIDERS.SPIREON]: () => 104,
      default: () => (window.$environment.APP_LAYOUT === 'NewUi' ? 82 : 74),
    },
    tabvalues_classname: {
      [SERVICE_PROVIDERS.SPIREON]: () => 'sublogwrapper',
      default: () => 'vehicleTabs',
    },
    tabvalues_vertical: {
      [SERVICE_PROVIDERS.SPIREON]: () => verticalTab,
      default: () => false,
    },
    default: () => true,
  };
};

export const checkServiceProvider = (key, provider, def = true, params = {}) =>
  providerCheckHandler({ key, provider, def, params }, getProviderCheck);
